export enum HeaderTabsKeys {
  Kit = 'kit',
  Resources = 'resources',
  About = 'about'
}
